import {WorkflowTemplateContainer} from './workflow-template-container';

export default {
    component: WorkflowTemplateContainer
};
